import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor($q, $scope, Alert) {
        this.$q = $q;
        this.$scope = $scope;
        this.Alert = Alert;
    }

    $onInit() {
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
    }

    cancel() {
        this.isEditing = false;
    }

    edit() {
        this.$value = this.initialValue;
        if(this.isPasswordHidden) {this.$value="V1kU94U33i"}
        this.isEditing = true;
    }

    generate() {
        this.isSaving = true;
        this.onGenerate()
            .then(password => this.$value = password)
            .finally(() => this.isSaving = false)
    }

    save() {
        this.isSaving = true;
        this.$q
            .resolve(this.onSave({$value: this.$value}))
            .finally(() => this.isEditing = this.isSaving = this.showPassword = false)
    }

    notModified() {
        return this.$value === this.initialValue;
    }

    onKeyUp($event) {
        if ($event.keyCode === 13) {
            this.form.$valid && !this.notModified() && this.save();
        } else if ($event.keyCode === 27) {
            this.cancel();
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-editable-password/sp-editable-password.controller.js